/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BooleanResponse } from '../../models/boolean-response';

export interface HasAccessToDataAnalytics$Params {
}

export function hasAccessToDataAnalytics(http: HttpClient, rootUrl: string, params?: HasAccessToDataAnalytics$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
  const rb = new RequestBuilder(rootUrl, hasAccessToDataAnalytics.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BooleanResponse>;
    })
  );
}

hasAccessToDataAnalytics.PATH = '/rest/data-analytics';
